<template>
    <div >
        <div class="form-group">
            <input type="text" name="fio" v-model="formParams.fio" placeholder="введите фамилию и имя..." class="form-control"  >
        </div>
        <div class="form-group">
            <input type="text" name="phone" v-model="formParams.phone" placeholder="введите телефон..." class="form-control"  >
        </div>
        <div class="form-group">
            <input type="email" name="email" v-model="formParams.email" placeholder="введите email..." class="form-control"  >
        </div>
        <div class="form-group">
            <input type="text" name="birthday" v-model="formParams.birthday" placeholder="введите день рождения..."  onfocus="(this.type='date')"  class="form-control"  >
        </div>
        <button class="btn btn-warning btn-custom" @click="register">Войти</button>
        <p class="spacer">&nbsp;</p>
        <p class="spacer">&nbsp;</p>
        <p class="spacer">&nbsp;</p>
    </div>
</template>

<script>
    export default {
        name: "RegistrationForm",
        data() {
            return {
                formParams: {}
            }
        },
        methods: {
            register() {
                const check = {
                    'fio' : 'ФИО',
                    'phone' : 'Телефон',
                    'email' : 'E-mail'
                }

                for (var prop in check) {
                    if(!this.formParams[prop]){
                        this.$modal.show('dialog', {
                            title: 'Ошибка регистрации',
                            text: 'Не заполнено поле ' + check[prop],
                            buttons: [{ title: 'Закрыть' }]
                        })
                        return;
                    }
                }

                this.$http.post('/register', this.formParams).then( response => {
                    const userData = response.data
                    if(userData.email){
                        window.location.href = '/customer/private/bio';
                    }else{
                        this.$modal.show('dialog', {
                            title: 'Ошибка регистрации',
                            text: userData.message,
                            buttons: [
                                {
                                    title: 'Закрыть'
                                }
                            ]
                        })
                    }
                }, error => {
                    error
                    this.$modal.show('dialog', {
                        title: 'Ошибка регистрации',
                        text: 'В процессе регистрации возникли непредвиденные проблемы. Мы уже работает над этим.',
                        buttons: [
                            {
                                title: 'Закрыть'
                            }
                        ]
                    })
                })
            }

        }
    }
</script>

<style scoped>

</style>